import { useContext } from "react";
import { KeycloakContext } from "./context";

export function useKeycloak() {
  const keycloak = useContext(KeycloakContext);

  if (!keycloak) {
    throw new Error(
      "useKeycloak hook must be used inside KeycloakProvider context"
    );
  }
  
  const { authenticated } = keycloak;
  return {
    authenticated,
    keycloak,
  };
}
